import {A} from "@solidjs/router";
import {FaSolidCircleUser} from "solid-icons/fa";
import {For, Show} from "solid-js";
import Collapsible from "~/components/ui/Collapsible";
import {useUser} from "~/context/UserContext";
import btn from "~/css/components/ui/button.module.css";
import icon from "~/css/components/ui/icon.module.css";
import css from "~/css/layout/account-nav.module.css";

const links = {
    "Account": "/dashboard/account",
    "Tags": "/dashboard/tags",
    "Pets": "/dashboard/pets",
    "Billing": "/dashboard/billing",
}

export default function AccountNav() {

    return (
        <Show when={useUser()!()} fallback={<A href="/auth/sign-in" class={btn.primary}>Sign In</A>}>
            <Collapsible>
                {api => (
                    <div {...api.getRootProps()} class={css.navContainer}>
                        <button {...api.getTriggerProps()}>
                            <FaSolidCircleUser class={icon.primary} size="2rem"/>
                        </button>
                        <div {...api.getContentProps()} class={css.nav}>
                            <For each={Object.entries(links)}>
                                {([title, path]) => (
                                    <A href={path} class={css.link} activeClass={css.active}>{title}</A>
                                )}
                            </For>
                        </div>
                    </div>
                )}
            </Collapsible>
        </Show>
    )
}